import React, { useState } from "react";
import { Alert, Button, Card, CardBody, Col, Row } from "reactstrap";
import CountUp from "react-countup";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";


const ReportCard = () => {
  const navigate =useNavigate();
  const data = [
    {
      type: "Male Customer",
      number: 1800,
      percentage: "16.24",
      increase: true,
      icon: "icon-male.svg",
    },
    {
      type: "Female Customer",
      number: 1500,
      percentage: "3.96",
      increase: false,
      icon: "icon-female.svg",
    },
    {
      type: "Child Customer",
      number: 500,
      percentage: "0.24",
      increase: false,
      icon: "icon-child.svg",
    },
    {
      type: "Defaulters",
      number: 100,
      percentage: "7.05",
      increase: true,
      icon: "Icon-defalturs.svg",
    },
  ];
  const handleNavigationForm = () => {
    navigate("/report-form"); // Replace with the actual path
  };

  return (
    <React.Fragment>
      <Row className="mt-auto">
        <Col xs={12}>
          <Card className="card-height-100">
            <CardBody className="p-0">
              <Alert
                className="alert alert-warning border-0 rounded-0 m-0 d-flex align-items-center"
                role="alert"
              >
                <i className="ri-question-line me-2"></i>
                <div
                  style={{ fontSize: "12px" }}
                  className="flex-grow-1 text-truncate"
                >
                  Your monthly report submission due in <b>2</b> days.
                </div>
                <div className="flex-shrink-0">
                  <Link
                    to="/pages-pricing"
                    className="text-reset text-decoration-underline"
                  >
                    <b></b>
                  </Link>
                </div>
              </Alert>

              <Row className="align-items-end">
                <Col sm={8}>
                  <div className="p-3">
                    <span style={{}}>Create your report for this month</span>
                    <div className="mt-5">
                      <Button
                        size="sm"
                        style={{
                          backgroundColor: "#3cd188",
                          borderColor: "#3cd188",
                        }}
                        className="btn  px-3 py-2"
                        onClick={handleNavigationForm}
                      >
                        Create new report
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col sm={4}>
                  <div className="px-3 py-2">
                    <img
                      src="th.jpg"
                      className="img-fluid"
                      alt=""
                      style={{ height: "100px", width: "" }}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        {data.map((item) => {
          return (
            <Col md={6}>
              <Card className="card-height-100 ">
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p
                        style={{ fontSize: "13px" }}
                        className="text-muted mb-0"
                      >
                        {item.type}
                      </p>
                      <h4 className="mt-4 ff-secondary fw-semibold">
                        <span className="counter-value">
                          <CountUp
                            start={0}
                            end={item.number}
                            // decimals={2}
                            duration={4}
                            separator=","
                          />
                        </span>
                      </h4>
                      <p
                        style={{ fontSize: "12px" }}
                        className="mb-0 text-muted"
                      >
                        <span
                          className={`badge bg-light ${item.increase ? "text-success" : "text-danger"
                            } mb-0`}
                        >
                          <i
                            className={`${item.increase
                              ? "ri-arrow-up-line"
                              : "ri-arrow-down-line"
                              } align-middle`}
                          ></i>{" "}
                          {item.percentage} %
                        </span>{" "}
                        vs. previous month
                      </p>
                    </div>
                    <div>
                      <div className="avatar-sm flex-shrink-0">
                        <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                          <img src={`${item.icon}`} alt="Icon" />
                        </span>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </Row>
      {/* <Row>
        <Col md={6}>
          <Card className="card-animate ">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <p className="fw-semibold text-muted mb-0">Male Customer</p>
                  <h4 className="mt-4 ff-secondary fw-semibold">
                    <span className="counter-value">
                      <CountUp
                        start={0}
                        end={1800}
                        // decimals={2}
                        duration={4}
                        separator=","
                      />
                    </span>
                  </h4>
                  <p style={{ fontSize: "12px" }} className="mb-0 text-muted">
                    <span className="badge bg-light text-success mb-0">
                      <i className="ri-arrow-up-line align-middle"></i> 16.24 %
                    </span>{" "}
                    vs. previous month
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                      <FeatherIcon icon="users" className="text-info" />
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <p className="fw-semibold text-muted mb-0">Female Customer</p>
                  <h2 className="mt-4 ff-secondary fw-semibold">
                    <span className="counter-value" data-target="97.66">
                      <CountUp
                        start={0}
                        end={1500}
                        // decimals={2}
                        duration={4}
                        separator=","
                      />
                    </span>
                  </h2>
                  <p className="mb-0 text-muted">
                    <span className="badge bg-light text-danger mb-0">
                      <i className="ri-arrow-down-line align-middle"></i> 3.96 %
                    </span>{" "}
                    vs. previous month
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                      <FeatherIcon icon="activity" className="text-info" />
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <p className="fw-semibold text-muted mb-0">Child Customer</p>
                  <h2 className="mt-4 ff-secondary fw-semibold">
                    <span className="counter-value">
                      <CountUp
                        start={0}
                        end={500}
                        // decimals={2}
                        duration={4}
                        separator=","
                      />
                    </span>
                  </h2>
                  <p className="mb-0 text-muted">
                    <span className="badge bg-light text-danger mb-0">
                      <i className="ri-arrow-down-line align-middle"></i> 0.24 %
                    </span>{" "}
                    vs. previous month
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                      <FeatherIcon icon="users" className="text-info" />
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex justify-content-between">
                <div>
                  <p className="fw-semibold text-muted mb-0">Defaulters</p>
                  <h2 className="mt-4 ff-secondary fw-semibold">
                    <span className="counter-value" data-target="33.48">
                      <CountUp start={0} end={100} decimals={2} duration={4} />
                    </span>
                  </h2>
                  <p className="mb-0 text-muted">
                    <span className="badge bg-light text-success mb-0">
                      <i className="ri-arrow-up-line align-middle"></i> 7.05 %
                    </span>{" "}
                    vs. previous month
                  </p>
                </div>
                <div>
                  <div className="avatar-sm flex-shrink-0">
                    <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                      <FeatherIcon icon="external-link" className="text-info" />
                    </span>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row> */}
    </React.Fragment>
  );
};

export default ReportCard;
